import Base from './components/cells/Base';
import TextTwoValues from './components/cells/TextTwoValues';

export default function TextTwoValuesCell() {}

TextTwoValuesCell.prototype.init = function (params) {
    this.eGui = Base(TextTwoValues(params), params);
    return;
};

TextTwoValuesCell.prototype.getGui = function () {
    return this.eGui;
};
